import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import {
  UsersTableSearchProps,
  UsersTableSortProps
} from './users-table-store.types'

export const initialUsersTableSearchProps: UsersTableSearchProps = {
  addedOnPeriod: null,
  email: '',
  name: '',
  roleId: '' as any,
  storeName: ''
}

export const initialUsersTablePaginationProps: PaginationProps<UsersTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: UsersTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const usersTableNeedTimeoutProps: Array<keyof UsersTableSearchProps> = [
  'name',
  'email',
  'storeName'
]
